module.exports = __webpack_public_path__ + "img/xcl.0f3d300.png";